import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph,
  Heading1,
  LinkStyled,
  Heading2,
  List,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import RowProductView from '../../components/grid/RowProductView';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Sodavand" activeSidemenu="Danskvand">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Danskvand</Heading1>
          <Paragraph>
            Danskvand er ganske simpelt det danske udtryk for vand med brus. Det er en forfriskende måde at nyde sin vand på og vi sælger varianter både med og uden citrus. Hos Skafte finder du de kendte mærker såsom Ramlösa og Egekilde danskvand, men vi fører også de lidt billigere alternativer fra Loka og Frem - her afspejler prisen dog langt fra kvaliteten. Ikke alle bryder sig om brus, så hvorfor ikke også sikre noget klassisk <LinkStyled to="/kildevand" title="Kildevand">kildevand</LinkStyled> til næste arrangement?
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="danskvand" display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Danskvand - et forfriskende valg</Heading2>
          <Paragraph>
            Når man tænker på en frisk og sprudlende drik, er danskvand ofte en af de første, der kommer i tankerne. Det er en klassisk drik, der er elsket af mange og kan findes på stort set enhver restaurant eller café - eller i køleskabet på arbejdet eller derhjemme.
          </Paragraph>
          <Paragraph>
            Danskvand er kendt for sin forfriskende smag, hvilket er en af årsagerne til at det er så populært at drikke. Den klare og sprudlende væske har en let og delikat smag, som kan give en følelse af opkvikkelse og glæde. Det er en drik, som kan nydes af alle - unge som gamle, og den er særligt populær som en forfriskning på varme sommerdage eller til maden under festen.
          </Paragraph>
          <Paragraph>
            Men danskvand er mere end bare en forfriskende drik. Det kan også være en god erstatning for andre sukkerholdige drikkevarer. Mange mennesker forsøger at begrænse deres indtag af sukker og kalorier, og her er danskvand en god løsning for dem, der ønsker at skære ned på sukkeret uden at gå på kompromis med smagen.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Find din favorit danskvand</Heading2>
          <Paragraph>
            Hos Skafte finder du et stort udvalg af danskvand i forskellige varianter og størrelser. Her kan du vælge mellem klassisk danskvand eller danskvand med smag.
          </Paragraph>
          <Paragraph>
            Vi fører læskende danskvand fra følgende producenter:
          </Paragraph>
          <List>
            <li>Egekilde danskvand</li>
            <li>Ramlösa danskvand</li>
            <li>Frem danskvand</li>
            <li>Loka danskvand</li>
          </List>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Klassisk danskvand eller danskvand med smag?</Heading2>
          <Paragraph>
            Skal din danskvand være med eller uden smag? Den helt klassiske danskvand er en evig klassiker, der ofte vælges som alternativ til almindeligt vand. Her er ingen tilsat smag og du oplever derfor kun den skønne perlende fornemmelse på tungen, når du drikker den.
          </Paragraph>
          <Paragraph>
            Må der derimod gerne ske lidt ekstra? Danskvand med citrus er en favorit, hvis der gerne må være en lille smagsoplevelse i forbindelse med drikken. Danskvand med citrus opleves en anelse mere frisk grundet den diskrete citrussmag og du vil opleve, at den i mange situationer sagtens kan erstatte en sodavand.
          </Paragraph>
          <Paragraph>
            Uanset hvilken type danskvand du foretrækker, vil du altid finde et stort udvalg af kvalitetsdanskvand hos Skafte.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>Danskvand er uundværligt til dit næste arrangement</Heading2>
          <Paragraph>
            Skal du holde fest, bryllup, jubilæum, event eller et helt femte arrangement? Du har sikkert allerede husket drikkevarer såsom øl og sodavand, men har du også husket danskvand?
            Selvom det er skønt at nyde både øl, sodavand og drinks, er det også rart at kunne tilbyde en forfriskende drik ved siden af, der er letdrikkelig og hverken indeholder alkohol eller sukker.
          </Paragraph>
          <Paragraph>
            Danskvand er et skønt alternativ til almindelig kildevand eller postevand og opleves en smule mere spændende grundet de perlende bobler.
          </Paragraph>
          <Paragraph>
            Bestil din danskvand hos Skafte og tilbyd dine gæster en forfriskende drik til din kommende fest.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
